import Cookies from "js-cookie";

// Everything the app keeps in cookies it can read. None of it is a credential:
// the session itself is an HttpOnly cookie that only the server can set or
// clear. "TOKEN" is where the session used to live, and is removed for anyone
// still holding one from before. Names match COOKIE_KEYS in App.js; kept apart
// from it so the request interceptor, which loads first, does not import App.
const UI_COOKIES = ["U_ID", "U_NAME", "U_TYPE", "TOKEN"];

export const clearSessionCookies = () => UI_COOKIES.forEach((name) => Cookies.remove(name));
